import { storeToRefs } from "pinia";

import { useGlobalAdminStore } from "src/stores/global";
import { useUserStore } from "src/stores/user";

export default ({ router }) => {
  router.beforeEach((to, _from, next) => {
    // redirect if already logged in
    const path = to.query && to.query.redirect ? to.query.redirect : "/";

    const userStore = useUserStore();
    const { isLoggedIn } = storeToRefs(userStore);

    if (to.path === "/sign-in" && isLoggedIn.value) return next({ path });

    // user must login
    if (to.path === "/sign-in" && !isLoggedIn.value) return next();

    // direct logout url
    if (to.path === "/logout") {
      userStore.logout();

      return next();
    }

    // not logged in or accessing page without login
    if (
      !isLoggedIn.value &&
      !to.matched.some((record) => record.meta.freeAccess)
    ) {
      // prevent login redirect loops and trim superfluous initial forward slash
      const redirect = to.fullPath.replace(/^\/(login)?/, "");

      return next({
        path: "/sign-in",
        query: redirect ? { redirect } : {},
      });
    }

    return next();
  });

  let timeout;

  const restrictAccess = (to) => {
    const userStore = useUserStore();
    const { hasAccessLevel } = userStore;

    if (!useGlobalAdminStore().globalDataLoaded) {
      // wait for global data to be loaded
      clearTimeout(timeout);
      timeout = setTimeout(() => restrictAccess(to), 100);
    } else if (to.path !== "/") {
      // restrict access to route, replace with root if access denied
      const route = [to && { ...to }, ...to.matched].find(
        ({ meta }) => meta?.accessLevel
      );

      const accessLevel = route?.meta?.accessLevel;

      if (!route || !hasAccessLevel(accessLevel)) {
        router.replace("/");
      }
    }
  };

  router.afterEach(restrictAccess);
};
